import { render, staticRenderFns } from "./FactoryPhaseSupportForm.vue?vue&type=template&id=992a3520&scoped=true&"
import script from "./FactoryPhaseSupportForm.vue?vue&type=script&lang=ts&"
export * from "./FactoryPhaseSupportForm.vue?vue&type=script&lang=ts&"
import style0 from "./FactoryPhaseSupportForm.vue?vue&type=style&index=0&id=992a3520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992a3520",
  null
  
)

export default component.exports